import { useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TermsAndPrivacy from './pages/TermsAndPrivacy';

function App() {
  const location = useLocation();
  const pathname = location.pathname;

  // Simple routing based on pathname
  if (pathname === '/terms-and-privacy') {
    return <TermsAndPrivacy />;
  }

  // Default to HomePage
  return <HomePage />;
}

export default App; 